import { RolodexEntryType } from 'types'

import { DrilldownSchemaConfig } from './ontologyTypes'

export const CORE_SCHEMA: DrilldownSchemaConfig = {
  typeNames: {
    [RolodexEntryType.ORGANIZATION]: 'Organization',
    [RolodexEntryType.SITE]: 'Site',
    [RolodexEntryType.UNIT]: 'Asset',
    [RolodexEntryType.COMPONENT]: 'Component',
    [RolodexEntryType.INSPECTION]: 'Inspection',
    [RolodexEntryType.JOB]: 'Job',
    [RolodexEntryType.INDICATION]: 'Indication',
    [RolodexEntryType.INDICATION_SET]: 'Indication Set',
    [RolodexEntryType.AS_PIPELINE_STATUS]: 'Advanced Services Pipeline Status',
    [RolodexEntryType.COMPONENT_DATASET]: 'Component Dataset',
    [RolodexEntryType.ASSET_MODEL]: 'Asset Model',
    [RolodexEntryType.POTREE_POINT_CLOUD]: 'Point Cloud',
  },
  typeToRequiredTags: {
    [RolodexEntryType.ORGANIZATION]: [],
    [RolodexEntryType.SITE]: [RolodexEntryType.ORGANIZATION],
    [RolodexEntryType.UNIT]: [
      RolodexEntryType.ORGANIZATION,
      RolodexEntryType.SITE,
    ],
    [RolodexEntryType.COMPONENT]: [
      RolodexEntryType.ORGANIZATION,
      RolodexEntryType.SITE,
      RolodexEntryType.UNIT,
    ],
    [RolodexEntryType.ASSET_MODEL]: [
      RolodexEntryType.ORGANIZATION,
      RolodexEntryType.SITE,
      RolodexEntryType.UNIT,
    ],
    [RolodexEntryType.INSPECTION]: [
      RolodexEntryType.ORGANIZATION,
      RolodexEntryType.SITE,
      RolodexEntryType.UNIT,
      RolodexEntryType.COMPONENT,
    ],
    [RolodexEntryType.JOB]: [
      RolodexEntryType.ORGANIZATION,
      RolodexEntryType.SITE,
      RolodexEntryType.UNIT,
      RolodexEntryType.COMPONENT,
    ],
    [RolodexEntryType.INDICATION_SET]: [
      RolodexEntryType.ORGANIZATION,
      RolodexEntryType.SITE,
      RolodexEntryType.UNIT,
      RolodexEntryType.INSPECTION,
      RolodexEntryType.COMPONENT,
    ],
    [RolodexEntryType.INDICATION]: [
      RolodexEntryType.ORGANIZATION,
      RolodexEntryType.SITE,
      RolodexEntryType.UNIT,
      RolodexEntryType.INDICATION_SET,
      RolodexEntryType.INSPECTION,
      RolodexEntryType.COMPONENT,
    ],
    [RolodexEntryType.AS_PIPELINE_STATUS]: [
      RolodexEntryType.ORGANIZATION,
      RolodexEntryType.SITE,
      RolodexEntryType.UNIT,
      RolodexEntryType.COMPONENT,
      RolodexEntryType.JOB,
      RolodexEntryType.INSPECTION,
    ],
    [RolodexEntryType.COMPONENT_DATASET]: [
      RolodexEntryType.ORGANIZATION,
      RolodexEntryType.SITE,
      RolodexEntryType.UNIT,
      RolodexEntryType.COMPONENT,
      RolodexEntryType.JOB,
      RolodexEntryType.INSPECTION,
    ],
    [RolodexEntryType.POTREE_POINT_CLOUD]: [
      RolodexEntryType.ORGANIZATION,
      RolodexEntryType.SITE,
    ],
  },
  fields: {
    'organization.name': { type: 'text', name: 'Organization Name' },
    'site.name': { type: 'text', name: 'Site Name' },
    'unit.name': { type: 'text', name: 'Asset Name' },
    'unit.erp_id': { type: 'text', name: 'ERP ID' },
    'component.name': { type: 'text', name: 'Component Name' },
    'asset-model.insulated': { type: 'boolean', name: 'Insulated' },
    'asset-model.type': {
      type: 'enum',
      name: 'Asset Type',
      allowedValues: [
        'vertical_tank',
        'horizontal_tank',
        'piping',
        'pressure_vessel',
        'legacy_boiler',
      ],
    },
    'inspection.date': { type: 'date', name: 'Inspection Date' },
    'inspection.inspection_type': {
      type: 'enum',
      name: 'Inspection Type',
      allowedValues: ['rug', 'raut', 'trilat', 'emat', 'manual'],
    },
    'inspection.x_bin_size': { type: 'number', name: 'X Bin Size' },
    'inspection.y_bin_size': { type: 'number', name: 'Y Bin Size' },
    'inspection.num_points': { type: 'number', name: 'Number of Points' },
    'inspection.ndt_method_type': { type: 'enum', name: 'NDT Method Type' },
    'inspection.units': { type: 'enum', name: 'Units' },
    'indication-set.title': {
      type: 'text',
      name: 'Name',
    },
    'indication-set.indication_set_type': {
      type: 'enum',
      name: 'Indication Set Type',
    },
    'indication.detail.damage_mechanism': {
      type: 'enum',
      name: 'Indication Damage Mech.',
    },
    'indication.classificationInfo.classification': {
      type: 'enum',
      name: 'Indication Classification',
    },
    'component-dataset.publishing_state': {
      type: 'enum',
      name: 'Status',
    },
    'job.status': {
      type: 'enum',
      name: 'Job Status',
    },
    'job.start_date': {
      type: 'date',
      name: 'Start Date',
    },
    'job.end_date': {
      type: 'date',
      name: 'End Date',
    },
  },
}
